import React, { useEffect, useRef, useState } from 'react';
import DropdownMenuPortal from '../../tasks/WorkOrders/QuickTasks/components/DropdownMenuPortal';
import { statusPillStyles } from './inlineCellStyles';

const InlineTypeCell = ({ rowData, mixIns }) => {
  const typeOptions = mixIns?.typeOptions || [];
  const currentTypeValue = rowData?._claimDamagePartId;
  const [selectedValue, setSelectedValue] = useState(currentTypeValue);
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    setSelectedValue(currentTypeValue);
    setOpen(false);
  }, [currentTypeValue]);

  if (!typeOptions.length) {
    return <span>{rowData?._typeLabel || rowData?.type || '-'}</span>;
  }

  const chooseOption = (optionValue) => {
    setOpen(false);
    const normalized = Number(optionValue);
    if (!Number.isNaN(normalized) && normalized !== selectedValue) {
      setSelectedValue(normalized);
      if (typeof mixIns?.onSaveType === 'function') {
        mixIns.onSaveType(rowData._id, normalized);
      }
    }
  };

  const selectedOption = typeOptions.find(
    (option) => Number(option.value) === Number(selectedValue)
  );
  const fallbackLabel = rowData?._typeLabel || rowData?.type;
  const displayLabel = selectedOption?.label || fallbackLabel || '-';
  const typeStyleIndex = selectedOption ? selectedOption.styleIndex || 0 : 0;
  const typeColors = [
    { backgroundColor: '#dbeafe', color: '#1e3a8a', borderColor: '#bfdbfe' },
    { backgroundColor: '#fef3c7', color: '#92400e', borderColor: '#fde68a' },
    { backgroundColor: '#e0f2fe', color: '#075985', borderColor: '#bae6fd' },
    { backgroundColor: '#ede9fe', color: '#5b21b6', borderColor: '#ddd6fe' },
    { backgroundColor: '#fce7f3', color: '#9d174d', borderColor: '#fbcfe8' },
    { backgroundColor: '#dcfce7', color: '#166534', borderColor: '#bbf7d0' },
  ];
  const typeVariant = typeColors[typeStyleIndex % typeColors.length];

  const toggleOpen = (event) => {
    event.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        className="status-pill-button"
        ref={buttonRef}
        onClick={toggleOpen}
        aria-haspopup="listbox"
        aria-expanded={open}
        style={{
          ...statusPillStyles.base,
          ...typeVariant,
          border: 'none',
        }}
        title="Click to edit type"
      >
        {displayLabel}
      </button>
      <DropdownMenuPortal anchorRef={buttonRef} open={open} onClose={() => setOpen(false)}>
        {typeOptions.map((option) => {
          const optionValue = Number(option.value);
          const isActive = optionValue === Number(selectedValue);
          return (
            <button
              key={option.value}
              type="button"
              className={`dropdown-item${isActive ? ' active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                chooseOption(optionValue);
              }}
            >
              {option.label}
            </button>
          );
        })}
      </DropdownMenuPortal>
    </div>
  );
};

export default InlineTypeCell;
